<template>
    <div class="content">
        <div class="container-fluid">
            <div v-if="messageAlert">
                <Notification :message="messageAlert" @statusAlertMsg="cambiarMsgAlert" />
            </div>
            <div>
                <DxDataGrid id="gridContainer" :data-source="redacciones" key-expr="id" :column-hiding-enabled="true"
                    :show-borders="true" @exporting="onExporting" :repaint-changes-only="true"
                    @cell-prepared="onCellPrepared">
                    <DxFilterPanel :visible="true" />
                    <DxFilterBuilderPopup :position="filterBuilderPopupPosition" />
                    <DxHeaderFilter :visible="true" />
                    <DxFilterRow :visible="true" />
                    <DxGrouping :context-menu-enabled="true" expand-mode="rowClick" />
                    <DxGroupPanel :visible="true"
                        empty-panel-text="Use el menú contextual de las columnas de encabezado para agrupar datos" />
                    <DxColumnChooser :enabled="true" mode="select" />
                    <DxExport :enabled="true" :formats="['pdf', 'xlsx']" />
                    <DxColumn dataField="id" caption="" :showInColumnChooser="false" :allowFiltering="false"
                        :allowSorting="false" cellTemplate="cellEditar" :fixed="true" width='5%' />
                    <DxColumn dataField="redaccion_r_id" caption="Redaccion" data-type="string" width="8%" />
                    <DxColumn dataField="redactor_nombre" caption="Redactor" data-type="string" />
                    <DxColumn dataField="cliente_empresa" caption="Cliente" data-type="string" />
                    <DxColumn dataField="website_sitio" caption="Website" data-type="string" />
                    <DxColumn dataField="estado_redactor_nombre" caption="Estado Redactor" data-type="string">
                        <DxLookup :data-source="lookupDataEdoRedactor" />
                    </DxColumn>
                    <DxColumn dataField="estado_cliente_nombre" caption="Estado Cliente" data-type="string">
                        <DxLookup :data-source="lookupDataEdoCliente" />
                    </DxColumn>
                    <DxColumn dataField="costo" caption="Costo" format="currency" data-type="number" />
                    <DxColumn dataField="precio" caption="Precio EUR" format="currency" data-type="number" />
                    <DxColumn dataField="titulo" caption="Título" data-type="string" />
                    <DxColumn dataField="brief" caption="Brief" data-type="string" />
                    <DxToolbar>
                        <DxItem location="before" name="groupPanel" />
                        <DxItem location="after" template="refreshTemplate" />
                        <DxItem location="after" name="exportButton" />
                        <DxItem location="after" name="columnChooserButton" />
                    </DxToolbar>
                    <template #refreshTemplate>
                        <DxButton icon="plus" @click="agregarRedaccion()" />
                    </template>
                    <DxPager :allowed-page-sizes="[5, 8, 15, 30]" :show-info="true" :show-navigation-buttons="true"
                        :show-page-size-selector="true" :visible="true" />
                    <template #cellEditar="{ data }">
                        <div class="text-center">
                            <a href="#" class="text-decoration-none fas fa-pen fa-sm me-2"
                                @click="abrirModalEditar(data)" title="Editar"></a>
                            <a href="#" class="text-decoration-none fas fa-eye fa-sm" @click="abrirModalShow(data)"
                                title="Mostrar"></a>
                        </div>
                    </template>
                    <DxPaging :page-size="8" />
                </DxDataGrid>
            </div>
            <dx-popup :height="'auto'" :showTitle="true" titleTemplate="titleModal" :dragEnabled="false"
                :hideOnOutsideClick="true" :visible="popupVisibleCreate" @hidden="onHidden">
                <template #titleModal>
                    <h3>{{ titleModal }}</h3>
                </template>
                <div>
                    <form action="">
                        <div class="form">
                            <div class="dx-fieldset">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <DxSelectBox label="Redactor:*" :search-enabled="true" :data-source="redactores"
                                            :search-mode="searchModeOption" :search-expr="searchExprOptionRedactor"
                                            :search-timeout="searchTimeoutOption"
                                            :min-search-length="minSearchLengthOption"
                                            :show-data-before-search="showDataBeforeSearchOption" display-expr="nombre"
                                            value-expr="id" v-model="redaccion.redactor_id" />
                                        <small class="error_message"
                                            v-for="(e_redactor_id, index) in errors.redactor_id" :key="index">{{
                                                e_redactor_id }}</small>
                                    </div>
                                    <div class="col-md-6">
                                        <DxSelectBox label="Cliente:*" :search-enabled="true" :data-source="clientes"
                                            :search-mode="searchModeOption" :search-expr="searchExprOptionCliente"
                                            :search-timeout="searchTimeoutOption"
                                            :min-search-length="minSearchLengthOption"
                                            :show-data-before-search="showDataBeforeSearchOption" display-expr="empresa"
                                            value-expr="id" v-model="redaccion.cliente_id" />
                                        <small class="error_message" v-for="(e_cliente_id, index) in errors.cliente_id"
                                            :key="index">{{ e_cliente_id }}</small>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <DxNumberBox label="Costo:*" v-model="redaccion.costo" format="$ #,##0.##" />
                                        <small class="error_message" v-for="(e_costo, index) in errors.costo"
                                            :key="index">{{
                                                e_costo }}</small>
                                    </div>
                                    <div class="col-md-6">
                                        <DxSelectBox label="Website:" :search-enabled="true" :data-source="websites"
                                            :search-mode="searchModeOption" :search-expr="searchExprOptionWebsite"
                                            :search-timeout="searchTimeoutOption"
                                            :min-search-length="minSearchLengthOption"
                                            :show-data-before-search="showDataBeforeSearchOption" display-expr="sitio"
                                            value-expr="id" v-model="redaccion.website_id" />
                                        <small class="error_message" v-for="(e_website_id, index) in errors.website_id"
                                            :key="index">{{ e_website_id }}</small>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <DxTextArea label="Brief:*" :height="80" :max-length="maxLength"
                                            v-model="redaccion.brief" />
                                        <small class="error_message" v-for="(e_brief, index) in errors.brief"
                                            :key="index">{{
                                                e_brief }}</small>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-10">
                                                <DxNumberBox label="Precio:*" v-model="redaccion.precio"
                                                    format="$ #,##0.##" />
                                                <small class="error_message" v-for="(e_precio, index) in errors.precio"
                                                    :key="index">{{
                                                        e_precio }}</small>
                                            </div>
                                            <div class="col-md-2 mt-3">EUR</div>
                                            <div class="col-md-12" v-if="option == 'edit'">
                                                <DxTextBox label="Título:*" v-model="redaccion.titulo" />
                                                <small class="error_message" v-for="(e_titulo, index) in errors.titulo"
                                                    :key="index">{{ e_titulo }}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2" v-if="option == 'edit'">
                                    <div class="col-md-6">
                                        <div class="row mb-2">
                                            <div class="col-2 mt-3">
                                                <DxCheckBox text="Redacción" v-model="redaccion.redaccion"
                                                    @value-changed="onValueChanged"
                                                    :disabled="redaccion.redaccion == true" />
                                            </div>
                                            <div class="col-10">
                                                <DxSelectBox label="Estado redactor:*" :search-enabled="true"
                                                    :data-source="estadoRedactor" :search-mode="searchModeOption"
                                                    :search-expr="searchExprOption"
                                                    :search-timeout="searchTimeoutOption"
                                                    :min-search-length="minSearchLengthOption"
                                                    :show-data-before-search="showDataBeforeSearchOption"
                                                    display-expr="nombre" value-expr="id"
                                                    v-model="redaccion.estado_redactor_id"
                                                    :disabled="redaccion.redaccion == 0"
                                                    @value-changed="onValueChangedEdoRedactor()" />
                                                <small class="error_message"
                                                    v-for="(e_estado_redactor_id, index) in errors.estado_redactor_id"
                                                    :key="index">{{
                                                        e_estado_redactor_id }}</small>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-md-6">
                                        <DxSelectBox label="Estado cliente:*" :search-enabled="true"
                                            :data-source="estadoCliente" :search-mode="searchModeOption"
                                            :search-expr="searchExprOption" :search-timeout="searchTimeoutOption"
                                            :min-search-length="minSearchLengthOption"
                                            :show-data-before-search="showDataBeforeSearchOption" display-expr="nombre"
                                            value-expr="id" v-model="redaccion.estado_cliente_id" />
                                        <small class="error_message"
                                            v-for="(e_estado_cliente_id, index) in errors.estado_cliente_id"
                                            :key="index">{{
                                                e_estado_cliente_id }}</small>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 d-flex justify-content-end">
                                        <dx-button class="me-2" type="normal" text="Cancelar"
                                            @click="cancelarEditar()"></dx-button>
                                        <dx-button class="me-2" v-if="option == 'save'" icon="save" type="default"
                                            text="Guardar" @click="nuevaRedaccion()"></dx-button>
                                        <dx-button class="me-2" v-if="option == 'edit'" icon="fas fa-lock fa-sm"
                                            type="default" text="Modificar" @click="actualizarRedaccion()"></dx-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </dx-popup>

            <dx-popup :height="'auto'" :showTitle="true" titleTemplate="titleModal" :dragEnabled="false"
                :hideOnOutsideClick="true" :visible="popupVisibleShow" @hidden="onHiddenShow">
                <template #titleModal>
                    <h3>Redacción: {{ redaccion.redaccion_r_id }}</h3>
                </template>
                <div>

                    <div class="form">
                        <div class="dx-fieldset">
                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <span>Redactor: {{ redaccion.redactor_nombre }}</span>
                                </div>
                                <div class="col-md-6">
                                    <span>Cliente: {{ redaccion.cliente_empresa }}</span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <span>Costo: {{ redaccion.costo }}</span>
                                </div>
                                <div class="col-md-6">
                                    <span>Website: {{ redaccion.website_sitio }}</span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <span>Brief: {{ redaccion.brief }}</span>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-10">
                                            <span>Precio: {{ redaccion.precio }} EUR</span>
                                        </div>
                                        <div class="col-md-12">
                                            <span>Título: {{ redaccion.titulo }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <div class="row mb-2">
                                        <div class="col-2 mt-3">
                                            <label :text="redaccion.redaccion ? 'Redacción' : 'Sin redacción'"></label>
                                        </div>
                                        <div class="col-10">Estado redactor:
                                            <a class="btn-custom"
                                                :style="{ background: redaccion.estado_redactor_color + ' 0% 0% no-repeat padding-box' }">
                                                {{ redaccion.estado_redactor_nombre }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    Estado cliente:
                                    <a class="btn-custom"
                                        :style="{ background: redaccion.estado_cliente_color + ' 0% 0% no-repeat padding-box' }">
                                        {{ redaccion.estado_cliente_nombre }}
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                    <br>
                    <hr>
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-end">
                            <dx-button class="me-2" type="normal" text="Cancelar" @click="cancelarShow()"></dx-button>
                            <dx-button class="me-2" type="default" text="Editar"
                                @click="abrirModalEditar(dataRedaccion)"></dx-button>
                        </div>
                    </div>
                </div>
            </dx-popup>
        </div>
    </div>
</template>
<script>
import {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxScrolling,
    DxPager,
    DxExport,
    DxHeaderFilter,
    DxFilterRow,
    DxColumnFixing,
    DxColumnChooser,
    DxSelection,
    DxStateStoring,
    DxGroupPanel,
    DxToolbar,
    DxEditing,
    DxGrouping,
    DxFilterPanel,
    DxFilterBuilderPopup,
} from 'devextreme-vue/data-grid';
import {
    DxValidator,
    DxRequiredRule,
    DxCustomRule
} from 'devextreme-vue/validator';

import { DxTextArea } from 'devextreme-vue/text-area';
import { DxTextBox } from 'devextreme-vue/text-box';
import { DxItem } from 'devextreme-vue/form';
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue/button';
import { DxCheckBox } from 'devextreme-vue';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import axios from "axios";
import Notification from "./NotificationComponent";
import 'devextreme/dist/css/dx.light.css';
import "bootstrap/dist/css/bootstrap.min.css";
import moment from 'moment';
import 'moment-timezone';

const lookupDataEdoCliente = [
    'Sin asignar',
    'Recibido',
    'Redactado',
    'Por cobrar',
    'Cobrado',
    'Cancelado',
    'En correción'
];

const lookupDataEdoRedactor = [
    'Sin asignar',
    'Recibido',
    'Listo para publicar',
    'Por pagar',
    'Pagado',
    'Cancelado',
    'En correción'
];

export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxLookup,
        DxForm,
        DxItem,
        DxTextArea,
        DxScrolling,
        DxPager,
        DxExport,
        DxHeaderFilter,
        DxFilterRow,
        DxColumnFixing,
        DxColumnChooser,
        DxSelection,
        DxStateStoring,
        DxGroupPanel,
        DxPopup,
        DxButton,
        DxTextBox,
        DxNumberBox,
        DxToolbar,
        DxValidator,
        DxRequiredRule,
        DxCustomRule,
        DxCheckBox,
        DxSelectBox,
        DxLoadPanel,
        Notification,
        DxEditing,
        DxGrouping,
        DxFilterPanel,
        DxFilterBuilderPopup,
    },
    data() {
        return {
            dataRedaccion:[],
            lookupDataEdoCliente,
            lookupDataEdoRedactor,
            filterBuilderPopupPosition: {
                of: window,
                at: 'top',
                my: 'top',
                offset: { y: 10 },
            },
            maxLength: null,
            redacciones: [],
            redactores: [],
            websites: [],
            clientes: [],
            redaccion: {
                id: '',
                redaccion_r_id:'',
                costo: '',
                brief: '',
                titulo: '',
                precio: '',
                redaccion: '',
                redactor_id: '',
                cliente_id: '',
                website_id: '',
                estado_redactor_id: '',
                estado_cliente_id: '',
                redactor_nombre: '',
                cliente_empresa: '',
                website_sitio: '',
                estado_redactor_nombre: '',
                estado_redactor_color: '',
                estado_cliente_nombre: '',
                estado_cliente_color: '',
            },
            estadoRedactor: [],
            estadoCliente: [],
            displayModes: [{ text: 'Display Mode \'full\'', value: 'full' }, { text: 'Display Mode \'compact\'', value: 'compact' }],
            displayMode: 'full',
            pageSizes: [5, 10, 'all'],
            showPageSizeSelector: true,
            showInfo: true,
            showNavButtons: true,
            errors: [],
            redaccion_id: "",
            titleModal: "",
            option: "save",
            popupVisibleCreate: false,
            popupVisibleDelete: false,
            popupVisibleStatus: false,
            popupVisibleShow: false,
            searchModeOption: 'contains',
            searchExprOptionRedactor: 'nombre',
            searchExprOptionCliente: 'empresa',
            searchExprOptionWebsite: 'sitio',
            searchExprOption: 'tipo',
            searchTimeoutOption: 200,
            minSearchLengthOption: 0,
            showDataBeforeSearchOption: false,
            isLoadPanelVisible: false,
            messageAlert: 0,
        }
    },
    methods: {
        onValueChangedEdoRedactor() {
            if (this.redaccion.estado_redactor_id == 3) {
                this.redaccion.estado_cliente_id = 3;
            }
            if (this.redaccion.estado_redactor_id == 7) {
                this.redaccion.estado_cliente_id = 7;
            }
        },
        onValueChanged(e) {
            if (e.value) {
                this.redaccion.estado_redactor_id = 2;
            }
        },
        cancelarShow() {
            this.cleanTextBox();
            this.hideChildModalShow();
            this.errors = [];
        },
        onHiddenShow(e) {
            this.cancelarShow();
        },
        hideChildModalShow() {
            this.popupVisibleShow = false;
        },
        showChildModalShow() {
            this.popupVisibleShow = true;
        },
        abrirModalShow(value) {
            this.dataRedaccion = value;
            this.option = "show";
            this.showChildModalShow();
            this.redaccion.redaccion_r_id = value.data.redaccion_r_id;
            this.redaccion.costo = value.data.costo;
            this.redaccion.brief = value.data.brief;
            this.redaccion.titulo = value.data.titulo;
            this.redaccion.precio = value.data.precio;
            this.redaccion.redaccion = value.data.redaccion;
            this.redaccion.redactor_id = value.data.redactor_id;
            this.redaccion.cliente_id = value.data.cliente_id;
            this.redaccion.website_id = value.data.website_id;
            this.redaccion.redactor_nombre = value.data.redactor_nombre;
            this.redaccion.cliente_empresa = value.data.cliente_empresa;
            this.redaccion.website_sitio = value.data.website_sitio;
            this.redaccion.estado_redactor_id = value.data.estado_redactor_id;
            this.redaccion.estado_cliente_id = value.data.estado_cliente_id;
            this.redaccion.estado_redactor_nombre = value.data.estado_redactor_nombre;
            this.redaccion.estado_redactor_color = value.data.estado_redactor_color;
            this.redaccion.estado_cliente_nombre = value.data.estado_cliente_nombre;
            this.redaccion.estado_cliente_color = value.data.estado_cliente_color;
        },
        onCellPrepared(e) {
            if (e.rowType === "data" && e.column.dataField === "estado_redactor_nombre") {
                e.cellElement.style.backgroundColor = e.data.estado_redactor_color;
                e.cellElement.style.color = "white";
                e.cellElement.style.borderRadius = "15px";
                e.cellElement.style.textAlign = "center"
                e.watch(function () {
                    return e.data.estado_redactor_nombre;
                }, function () {

                    e.cellElement.style.backgroundColor = e.data.estado_redactor_color;
                    e.cellElement.style.color = "white";
                    e.cellElement.style.borderRadius = "15px";
                    e.cellElement.style.textAlign = "center"
                })
            }
            if (e.rowType === "data" && e.column.dataField === "estado_cliente_nombre") {
                e.cellElement.style.backgroundColor = e.data.estado_cliente_color;
                e.cellElement.style.color = "white";
                e.cellElement.style.borderRadius = "15px";
                e.cellElement.style.textAlign = "center"
                e.watch(function () {
                    return e.data.estado_redactor_cliente;
                }, function () {
                    e.cellElement.style.backgroundColor = e.data.estado_cliente_color;
                    e.cellElement.style.color = "white";
                    e.cellElement.style.borderRadius = "15px";
                    e.cellElement.style.textAlign = "center"
                })
            }
        },
        onExporting(e) {
            e.component.columnOption('id', 'visible', false);
            //e.component.columnOption('notas', 'visible', false);
            if (e.format === 'xlsx') {
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Main sheet');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet,
                    customizeCell: function (options) {
                        const excelCell = options;
                        excelCell.font = { name: 'Arial', size: 12 };
                        excelCell.alignment = { horizontal: 'left' };
                    }
                }).then(function () {
                    workbook.xlsx.writeBuffer()
                        .then(function (buffer) {
                            e.component.columnOption('id', 'visible', true);
                            e.component.columnOption('notas', 'visible', true);
                            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'redacciones.xlsx');
                        });
                });
                e.cancel = true;
            }
            else if (e.format === 'pdf') {
                const doc = new jsPDF('l', 'mm', [297, 210]);
                exportDataGridToPdf({
                    jsPDFDocument: doc,
                    component: e.component
                }).then(() => {
                    e.component.columnOption('id', 'visible', true);
                    e.component.columnOption('notas', 'visible', true);
                    doc.save('redacciones.pdf');
                })
            }
        },
        cambiarMsgAlert(value) {
            this.messageAlert = value;
        },
        cleanTextBox() {
            this.redaccion.id = "";
            this.redaccion.redaccion_r_id = "";
            this.redaccion.costo = "";
            this.redaccion.brief = "";
            this.redaccion.titulo = "";
            this.redaccion.precio = "";
            this.redaccion.redaccion = "";
            this.redaccion.redactor_id = "";
            this.redaccion.cliente_id = "";
            this.redaccion.website_id = "";
            this.redaccion.estado_redactor_id = "";
            this.redaccion.estado_cliente_id = "";
            this.redaccion.redactor_nombre  = "";
            this.redaccion.cliente_empresa  = "";
            this.redaccion.website_sitio = "";
            this.redaccion.estado_redactor_nombre = "";
            this.redaccion.estado_redactor_color = "";
            this.redaccion.estado_cliente_nombre = "";
            this.redaccion.estado_cliente_color = "";
        },
        agregarRedaccion() {
            this.cleanTextBox();
            this.showChildModal();
            this.titleModal = "Nueva redacción"
            this.option = "save";
            this.redaccion.estado_redactor_id = 1;
            this.redaccion.estado_cliente_id = 1;
        },
        showChildModal() {
            this.popupVisibleCreate = true;
        },
        nuevaRedaccion() {
            axios.post('redacciones', this.redaccion).then(response => {
                if (response && response.data.statusCode == 200) {
                    this.messageAlert = response.data.message;
                    this.cleanTextBox();
                    this.hideChildModal();
                    this.getList();
                }
                else {
                    console.log(response);
                }
            }).catch((error) => {
                if (error.response.status == 422) {
                    this.errors = error.response.data.errors;
                } else {
                    console.log(this.errors);
                }
            });
        },
        hideChildModal() {
            this.popupVisibleCreate = false;
        },
        abrirModalEditar(value) {
            this.titleModal = "Editar redacción"
            this.option = "edit";
            this.cleanTextBox();
            this.showChildModal();
            this.redaccion_id = value.value;
            this.redaccion.id = value.value;
            this.redaccion.redaccion_r_id = value.data.redaccion_r_id;
            this.redaccion.costo = value.data.costo_org;
            this.redaccion.brief = value.data.brief;
            this.redaccion.titulo = value.data.titulo;
            this.redaccion.precio = value.data.precio_org;
            this.redaccion.redaccion = value.data.redaccion;
            this.redaccion.redactor_id = value.data.redactor_id;
            this.redaccion.cliente_id = value.data.cliente_id;
            this.redaccion.website_id = value.data.website_id;
            this.redaccion.estado_redactor_id = value.data.estado_redactor_id;
            this.redaccion.estado_cliente_id = value.data.estado_cliente_id;
        },
        cancelarEditar() {
            this.cleanTextBox();
            this.hideChildModal();
            this.hideChildModalShow();
            this.errors = [];
        },
        onHidden(e) {
            this.cancelarEditar();
        },
        actualizarRedaccion() {
            console.log(this.redaccion_id);
            console.log(this.redaccion);

            axios.put('redacciones/' + this.redaccion_id, this.redaccion).then(response => {
                if (response && response.data.statusCode == 200) {
                    this.messageAlert = response.data.message;
                    this.cleanTextBox();
                    this.hideChildModal();
                    this.hideChildModalShow();
                    this.getList();
                }
                else {
                    console.log(response);
                }
            }).catch((error) => {
                if (error.response.status == 422) {
                    this.errors = error.response.data.errors;
                } else {
                    console.log(this.errors);
                }
            });
        },
        getList() {
            let hoy = moment().tz('America/Mexico_City');
            const options = { style: 'currency', currency: 'MXN' };
            const numberFormat = new Intl.NumberFormat('es-MX', options);
            axios.get('listar-redacciones').then(response => {
                let redacciones = response.data.redacciones;
                redacciones.map(function (dato) {
                    let fecha_estado_redactor = moment(dato.fecha_estado_redactor).tz('America/Mexico_City');
                    let horas = hoy.diff(fecha_estado_redactor, 'hours');
                    if (dato.estado_redactor_id == 3 && horas > 24) {
                        dato.estado_redactor_id = 4;
                        dato.estado_redactor_nombre = "Por pagar";
                        dato.estado_redactor_color = "#0000FF";
                        dato.estado_cliente_id = 4;
                        dato.estado_cliente_nombre = "Por cobrar";
                        dato.estado_cliente_color = "#0000FF";
                    }
                    dato.costo = numberFormat.format(dato.costo);
                    dato.precio = numberFormat.format(dato.precio);
                    dato.redaccion_r_id = 'R' + dato.redaccion_r_id;
                    return dato;
                });
                this.redacciones = redacciones;
                this.redactores = response.data.redactores;
                this.websites = response.data.websites;
                this.clientes = response.data.clientes;
                this.estadoRedactor = response.data.estado_redactor;
                this.estadoCliente = response.data.estado_cliente;
            })
        },
    },
    mounted() {
        this.getList();
    },
}
</script>
<style scoped>
.small {
    font-size: smaller;
}

.error_message {
    color: #FF6868;
    font-weight: normal !important;
}

.active_password {
    font-size: smaller;
    color: #33FFA9;
}

.desactive_password {
    font-size: smaller;
    color: #C4C4C4;
    transition: all 0.3s;
}

.btn-custom {
    display: inline-block;
    color: #fff;
    letter-spacing: 0;
    border-radius: 15px;
    padding: 2px 18px;
    text-transform: uppercase;
    border: none;
    cursor: pointer;
    text-decoration: none;
}

.warning-tag {
    display: block;
    background-color: #ffeb3b;
    /* Amarillo de advertencia */
    color: #000;
    /* Texto negro */
    font-family: Arial, sans-serif;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    border-radius: 8px;
    /* Bordes redondeados */
    width: 100%;
    /* Ocupa todo el ancho disponible */
    box-sizing: border-box;
    /* Incluye padding en el ancho total */
    margin: 0 auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    /* Sombra sutil opcional */
}
</style>
